export default "__VITE_ASSET__uwnulzcY__"